import { render, staticRenderFns } from "./jourDetails.vue?vue&type=template&id=0f385b4b&scoped=true&"
import script from "./jourDetails.vue?vue&type=script&lang=js&"
export * from "./jourDetails.vue?vue&type=script&lang=js&"
import style0 from "./jourDetails.vue?vue&type=style&index=0&id=0f385b4b&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f385b4b",
  null
  
)

export default component.exports